/* Calibre — estado de scroll de la cabecera.
   Sin listener de scroll: un centinela de 1px observado una sola vez.
   Todo lo demás es CSS ligado al scroll. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var wrapper = document.querySelector('.page-wrapper') || document.body;
    var sentinel = document.createElement('div');
    sentinel.className = 'cal-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    var main = document.getElementById('MainContent') || wrapper;
    if (main.parentNode) main.parentNode.insertBefore(sentinel, main);

    var io = new IntersectionObserver(
      function (entries) {
        document.body.dataset.calScrolled = entries[0].isIntersecting ? 'false' : 'true';
      },
      { root: wrapper === document.body ? null : wrapper, threshold: 0 }
    );
    io.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   Dial de curvatura.
   Las seis curvas son el mismo bezier: seis números. Al elegir otra, se
   interpolan esos seis números y la línea SE DOBLA. No hay cambio de imagen
   ni fundido, que es lo que hace que se lea como un instrumento y no como
   una galería.
   -------------------------------------------------------------------------- */
(function () {
  var raiz = document.querySelector('[data-cal-dial]');
  if (!raiz) return;

  var vivo = raiz.querySelector('[data-dial-live]');
  var punta = raiz.querySelector('[data-dial-tip]');
  var glifo = raiz.querySelector('[data-dial-glyph]');
  var opciones = Array.prototype.slice.call(raiz.querySelectorAll('[data-dial-opt]'));
  var enlace = raiz.querySelector('[data-dial-url]');
  var salidas = {
    grados: raiz.querySelector('[data-dial-grados]'),
    note: raiz.querySelector('[data-dial-note]'),
    grosor: raiz.querySelector('[data-dial-grosor]')
  };
  if (!vivo || !opciones.length) return;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var actual = leer(opciones.find(function (o) { return o.getAttribute('aria-checked') === 'true'; }) || opciones[0]);
  var anim = null;
  var seguro = null;

  function leer(el) {
    return el.dataset.geo.trim().split(/\s+/).map(Number);
  }

  function pintar(n) {
    vivo.setAttribute('d', 'M60 430 C ' + n[0] + ' ' + n[1] + ', ' + n[2] + ' ' + n[3] + ', ' + n[4] + ' ' + n[5]);
    if (punta) { punta.setAttribute('cx', n[4]); punta.setAttribute('cy', n[5]); }
  }

  function irA(destino) {
    if (anim) cancelAnimationFrame(anim);
    if (quieto) { actual = destino.slice(); pintar(actual); return; }
    var desde = actual.slice();
    var t0 = null;
    var dur = 380;
    // Si la pestaña está en segundo plano el navegador congela rAF y la curva
    // se quedaría a medias. Este seguro pinta el destino igual.
    clearTimeout(seguro);
    seguro = setTimeout(function () {
      if (anim) cancelAnimationFrame(anim);
      actual = destino.slice();
      pintar(actual);
    }, dur + 80);
    function paso(t) {
      if (t0 === null) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      // misma curva de suavizado que usa el resto del tema
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      var n = desde.map(function (v, i) { return v + (destino[i] - v) * e; });
      pintar(n);
      if (p < 1) { anim = requestAnimationFrame(paso); } else { actual = destino.slice(); clearTimeout(seguro); }
    }
    anim = requestAnimationFrame(paso);
  }

  function texto(el, valor) {
    if (!el || !valor) return;
    el.textContent = valor;
  }

  function seleccionar(op) {
    opciones.forEach(function (o) { o.setAttribute('aria-checked', String(o === op)); });
    irA(leer(op));
    if (glifo) {
      glifo.dataset.cambio = '1';
      setTimeout(function () {
        glifo.textContent = op.dataset.label || '';
        delete glifo.dataset.cambio;
      }, quieto ? 0 : 120);
    }
    texto(salidas.grados, op.dataset.grados);
    texto(salidas.note, op.dataset.note);
    texto(salidas.grosor, op.dataset.grosor);
    if (enlace && op.dataset.url) enlace.setAttribute('href', op.dataset.url);
  }

  opciones.forEach(function (op, i) {
    op.addEventListener('click', function () { seleccionar(op); });
    op.addEventListener('mouseenter', function () { if (!quieto) irA(leer(op)); });
    op.addEventListener('focus', function () { seleccionar(op); });
    op.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0);
      if (!d) return;
      e.preventDefault();
      opciones[(i + d + opciones.length) % opciones.length].focus();
    });
  });

  // al salir del dial vuelve a la curva elegida, no se queda en la última que se rozó
  var dial = raiz.querySelector('.cal-curvas__dial');
  if (dial) {
    dial.addEventListener('mouseleave', function () {
      var sel = opciones.find(function (o) { return o.getAttribute('aria-checked') === 'true'; });
      if (sel) irA(leer(sel));
    });
  }
})();

/* --------------------------------------------------------------------------
   Lo que ya va en el pedido.
   La confirmación de "agregado" vive en la propia tarjeta y se acumula: esta
   compradora lleva cinco bandejas del mismo largo, no una, y sacarla a un
   cajón lateral en cada clic le rompe el recorrido.
   -------------------------------------------------------------------------- */
(function () {
  var CUENTA = {};

  function tarjetas() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.product-grid__item[data-product-id], .cal-mini[data-product-id]')
    );
  }

  function pintar() {
    tarjetas().forEach(function (el) {
      var id = el.dataset.productId;
      var n = CUENTA[id] || 0;
      var ledger = el.querySelector('[data-ledger]') || el.querySelector('.cal-ledger');
      if (n > 0) {
        el.setAttribute('data-en-pedido', String(n));
        if (ledger) ledger.textContent = 'En el pedido x' + n;
      } else {
        el.removeAttribute('data-en-pedido');
        if (ledger) ledger.textContent = '';
      }
      // la tarjeta no cambia de forma: el botón siempre dice lo mismo
    });
  }

  function leerCarrito() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items) return;
        CUENTA = {};
        c.items.forEach(function (it) {
          var k = String(it.product_id);
          CUENTA[k] = (CUENTA[k] || 0) + it.quantity;
        });
        pintar();
      })
      .catch(function () {});
  }

  // Dos arreglos de markup que el tema no permite hacer desde Liquid:
  // 1. la lámina de compra se muda DENTRO del pozo de la foto, para que se
  //    monte sobre la imagen y no empuje el texto de la tarjeta;
  // 2. se siembra el renglón del pedido, que el tema no trae.
  function acomodarTarjetas() {
    document.querySelectorAll('.product-grid__item').forEach(function (li) {
      var bb = li.querySelector('.buy-buttons-block');
      var pozo = li.querySelector('.card-gallery, .product-media-container');
      if (bb && pozo && bb.parentNode !== pozo) pozo.appendChild(bb);
      if (!li.querySelector('.cal-ledger')) {
        var contenido = li.querySelector('.product-card__content') || li;
        var s = document.createElement('span');
        s.className = 'cal-ledger';
        s.setAttribute('aria-live', 'polite');
        contenido.appendChild(s);
      }
    });
  }

  // Antes esto encadenaba cuatro llamadas: agregar, releer el carrito,
  // renderizar el cajón y releer otra vez. Se sentía lento porque lo era.
  // Ahora la tarjeta responde AL INSTANTE y hay una sola llamada a la red,
  // que además trae ya renderizado el cajón del carrito.

  function pintarCajon(html) {
    if (!html) return;
    var destino = document.getElementById('shopify-section-cart-drawer-section');
    if (!destino) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var nuevoNodo = tmp.querySelector('#shopify-section-cart-drawer-section') || tmp.firstElementChild;
    if (nuevoNodo) destino.replaceWith(nuevoNodo);
  }

  function contarDesde(html) {
    if (!html) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var badge = tmp.querySelector('.theme-drawer__badge');
    var n = badge ? parseInt(badge.textContent.trim(), 10) : NaN;
    return isNaN(n) ? null : n;
  }

  function actualizarContador(n) {
    if (n === null) return;
    document.querySelectorAll('.theme-drawer__badge, [data-cart-count]').forEach(function (el) {
      if (!el.children.length && (/^\d+$/.test(el.textContent.trim()) || el.dataset.cartCount !== undefined)) el.textContent = n;
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      var contador = el.querySelector('[ref="cartBubbleCount"]');
      if (!contador) return;
      contador.textContent = n < 100 ? String(n) : '';
      contador.classList.toggle('hidden', n === 0);
      el.classList.toggle('visually-hidden', n === 0);
      el.toggleAttribute('data-maintain-ratio', n <= 99);
    });
  }

  function abrirCajon() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.open === 'function') d.open();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var tarjeta = form.closest('.product-grid__item[data-product-id], .cal-mini[data-product-id]');
    // Los sugeridos del carrito lateral tambien se agregan sin salir de la
    // pagina. Antes no calzaban con el selector de arriba, el manejador se
    // rendia y el formulario se enviaba de forma nativa: la clienta terminaba
    // en /cart en vez de quedarse en el cajon.
    var sugerido = form.closest('.cal-sug');
    if (!tarjeta && !sugerido) return; // en la ficha actúa el componente del tema
    e.preventDefault();

    var id = tarjeta ? tarjeta.dataset.productId : null;
    var previo = id ? (CUENTA[id] || 0) : 0;

    if (id) {
      // 1. respuesta inmediata: la tarjeta ya muestra el contador
      CUENTA[id] = previo + 1;
      pintar();
    }
    if (sugerido) {
      sugerido.classList.add('cal-sug--cargando');
    }

    // 2. una sola llamada, que además devuelve el cajón ya renderizado
    var datos = new FormData(form);
    datos.append('sections', 'cart-drawer-section');
    datos.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', { method: 'POST', body: datos, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (d) {
        var html = d && d.sections ? d.sections['cart-drawer-section'] : null;
        // En el carrito la lista de sugeridos se vuelve a pintar entera, pero
        // la tira del menu no: si no se limpia aca, la tarjeta queda apagada
        // para siempre despues de agregar.
        if (sugerido) sugerido.classList.remove('cal-sug--cargando');
        actualizarContador(contarDesde(html));
        pintarCajon(html);
        // Si se agrego desde la tira del menu, primero se cierra ese cajon:
        // dos paneles abiertos a la vez tapan el carrito y dejan el scroll
        // bloqueado por partida doble.
        var menu = document.querySelector('.cal-searchbar__menu');
        if (menu && typeof menu.close === 'function' && menu.querySelector('details[open]')) menu.close();
        abrirCajon();
      })
      .catch(function () {
        // si falló, se deshace lo que se había pintado y se avisa con el envío normal
        if (id) { CUENTA[id] = previo; pintar(); }
        if (sugerido) sugerido.classList.remove('cal-sug--cargando');
        form.submit();
      });
  });

  // el tema agrega desde su propio componente: escuchamos y releemos
  ['cart:update', 'cart:refresh', 'CartUpdateEvent'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(leerCarrito, 60); });
  });

  // El modulo del regalo necesita repintar el cajon despues de agregar o
  // quitar su linea. Se expone el MISMO camino que usa el resto, para no
  // tener dos maneras distintas de renderizar el carrito.
  window.calibreCarrito = {
    // OJO: el GET a "?sections=cart-drawer-section" NO sirve desde una
    // coleccion; Shopify responde solo con las secciones de esa plantilla y
    // descarta el cajon sin avisar. Los endpoints del carrito si lo renderizan
    // cuando se les pasa sections + sections_url, que es el mismo camino que
    // ya usa el boton de agregar.
    refrescar: function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: {},
          sections: 'cart-drawer-section',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var html = d && d.sections ? d.sections['cart-drawer-section'] : null;
          pintarCajon(html);
          actualizarContador(contarDesde(html));
          return leerCarrito();
        })
        .catch(function () {});
    }
  };

  acomodarTarjetas();
  leerCarrito();
})();

/* --------------------------------------------------------------------------
   Regalo por monto.

   Reparto de responsabilidades, y conviene tenerlo claro:
     - Shopify pone el PRECIO EN CERO, con el descuento automatico
       "Regalo por compras sobre $100.000". Eso es lo que se respeta en el
       checkout.
     - Este archivo solo pone y saca la LINEA del carrito, que es la parte
       que Shopify no hace solo.
   Si alguien borra o pausa el descuento, el producto se cobra: nunca hay que
   fiarse de que el tema deje algo gratis.

   La linea se agrega con la propiedad _regalo. Gracias a eso, si la clienta
   compra ese mismo producto por su cuenta, esa otra linea no se toca.

   CUIDADO CON EL BUCLE: poner o sacar la linea repinta el cajon, y repintar
   el cajon dispara al observador otra vez. La primera version vigilaba todo
   el documento y sin freno, y Shopify respondio 429 por exceso de peticiones.
   De ahi los tres seguros: retardo, firma del estado ya intentado y pausa
   larga si algo falla.
   -------------------------------------------------------------------------- */
(function () {
  var RETARDO = 250;
  var PAUSA_ERROR = 20000;

  var trabajando = false;
  var intentado = '';
  var pausaHasta = 0;
  var reloj = null;

  function bloque() { return document.querySelector('[data-cal-regalo]'); }

  function programar() {
    clearTimeout(reloj);
    reloj = setTimeout(revisar, RETARDO);
  }

  function revisar() {
    if (trabajando || Date.now() < pausaHasta) return;
    var b = bloque();
    if (!b) return;

    var umbral = parseInt(b.dataset.umbral, 10);
    var base = parseInt(b.dataset.base, 10);
    var variante = b.dataset.variante;
    var puesto = b.dataset.puesto === '1';
    if (!umbral || !variante || isNaN(base)) return;

    var falta = base >= umbral && !puesto;
    var sobra = base < umbral && puesto;
    if (!falta && !sobra) { intentado = ''; return; }

    // Firma del estado: si ya se actuo sobre exactamente este carrito y el
    // cajon sigue mostrando lo mismo, no se vuelve a pedir nada.
    var firma = base + '|' + (puesto ? 1 : 0);
    if (firma === intentado) return;
    intentado = firma;

    if (falta) poner(variante); else sacar();
  }

  function cuerpo(extra) {
    var d = { sections: 'cart-drawer-section', sections_url: window.location.pathname };
    for (var k in extra) d[k] = extra[k];
    return JSON.stringify(d);
  }

  function pedir(url, datos) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: cuerpo(datos)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function poner(variante) {
    trabajando = true;
    pedir('/cart/add.js', {
      items: [{ id: Number(variante), quantity: 1, properties: { _regalo: '1' } }]
    }).then(pintar).catch(fallo);
  }

  function sacar() {
    trabajando = true;
    // change.js necesita ubicar la linea: el mismo producto puede estar dos
    // veces, una comprada y otra de regalo, y solo se toca la de regalo.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (c) {
        var linea = 0;
        for (var i = 0; i < c.items.length; i++) {
          if (c.items[i].properties && c.items[i].properties._regalo) { linea = i + 1; break; }
        }
        if (!linea) { trabajando = false; return; }
        return pedir('/cart/change.js', { line: linea, quantity: 0 }).then(pintar);
      })
      .catch(fallo);
  }

  function pintar(d) {
    var html = d && d.sections ? d.sections['cart-drawer-section'] : null;
    var destino = document.getElementById('shopify-section-cart-drawer-section');
    if (html && destino) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var nodo = tmp.querySelector('#shopify-section-cart-drawer-section') || tmp.firstElementChild;
      if (nodo) destino.replaceWith(nodo);
    }
    trabajando = false;
  }

  function fallo() {
    // Puede ser un 429 por haber pedido de mas: se para un rato largo en vez
    // de insistir, que es lo que agrava el problema.
    pausaHasta = Date.now() + PAUSA_ERROR;
    trabajando = false;
  }

  ['cart:update', 'cart:refresh', 'CartUpdateEvent'].forEach(function (ev) {
    document.addEventListener(ev, programar);
  });

  // Se vigila SOLO el contenedor del cajon, no el documento entero.
  var destino = document.getElementById('shopify-section-cart-drawer-section');
  var raiz = destino ? destino.parentElement : null;
  if (raiz) new MutationObserver(programar).observe(raiz, { childList: true, subtree: true });

  programar();
})();

/* --------------------------------------------------------------------------
   "Default Title" no debería verse nunca en la tienda. En el carrito lateral
   el tema imprime la variante aunque el producto tenga una sola, y ahí sale
   "Título: Default Title". Se limpia solo esa fila, no todas las variantes:
   Curva, Largo y Grosor sí tienen que verse.
   -------------------------------------------------------------------------- */
(function () {
  function limpiar(raiz) {
    (raiz || document).querySelectorAll('.cart-items__variants dd').forEach(function (dd) {
      if (dd.textContent.trim() === 'Default Title') {
        var fila = dd.closest('div') || dd.parentElement;
        if (fila) fila.classList.add('cal-oculto');
      }
    });
  }
  limpiar();
  ['cart:update', 'cart:refresh', 'CartUpdateEvent'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(limpiar, 60); });
  });
  new MutationObserver(function () { limpiar(); }).observe(document.documentElement, { childList: true, subtree: true });
})();


/* --------------------------------------------------------------------------
   El contador de la tarjeta. Cambia la cantidad en el carrito sin abrir nada.
   -------------------------------------------------------------------------- */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mas], [data-menos]');
    if (!btn) return;
    var tarjeta = btn.closest('[data-variant-id]');
    if (!tarjeta) return;
    e.preventDefault();
    var paso = btn.closest('[data-step]');
    var cuenta = paso.querySelector('[data-cuenta]');
    var actual = parseInt(cuenta.textContent, 10) || 0;
    var nueva = btn.hasAttribute('data-mas') ? actual + 1 : actual - 1;
    if (nueva < 0) nueva = 0;
    paso.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: tarjeta.dataset.variantId, quantity: nueva })
    })
      .then(function (r) { return r.json(); })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
      .catch(function () {})
      .then(function () { paso.querySelectorAll('button').forEach(function (b) { b.disabled = false; }); });
  });
})();


/* --------------------------------------------------------------------------
   El riel avanza solo, de a una tarjeta cada pocos segundos.

   Antes se apagaba para siempre con cualquier rueda del mouse, y como el
   scroll vertical de la página también dispara ese evento, bastaba con bajar
   por la home para que el riel no volviera a moverse nunca. Ahora solo se
   pausa mientras hay interacción de verdad, y retoma sola.
   -------------------------------------------------------------------------- */
(function () {
  var PASO_CADA = 4500;
  var ESPERA_TRAS_TOCAR = 12000;
  var rieles = document.querySelectorAll('[data-runner]');
  if (!rieles.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  Array.prototype.forEach.call(rieles, function (riel) {
    var encima = false;
    var pausaHasta = 0;

    function ancho() {
      var t = riel.querySelector('.cal-mini, [data-runner-item]');
      return t ? t.offsetWidth + 20 : riel.clientWidth * 0.5;
    }
    function visible() {
      var r = riel.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }
    function paso() {
      if (encima || Date.now() < pausaHasta) return;
      if (document.hidden || !visible()) return;
      var max = riel.scrollWidth - riel.clientWidth;
      if (max < 8) return;
      var fin = riel.scrollLeft >= max - 8;
      riel.scrollTo({ left: fin ? 0 : riel.scrollLeft + ancho(), behavior: 'smooth' });
    }
    function tocar() { pausaHasta = Date.now() + ESPERA_TRAS_TOCAR; }

    riel.addEventListener('mouseenter', function () { encima = true; }, { passive: true });
    riel.addEventListener('mouseleave', function () { encima = false; }, { passive: true });
    riel.addEventListener('focusin', function () { encima = true; }, { passive: true });
    riel.addEventListener('focusout', function () { encima = false; }, { passive: true });
    // solo cuenta como interacción de verdad arrastrar o tocar el riel
    riel.addEventListener('pointerdown', tocar, { passive: true });
    riel.addEventListener('touchstart', tocar, { passive: true });

    setInterval(paso, PASO_CADA);
  });
})();

/* --------------------------------------------------------------------------
   Flechas del carrusel de producto, como en la referencia. Mejora progresiva:
   sin JavaScript el riel sigue moviéndose con scroll.
   -------------------------------------------------------------------------- */
(function () {
  var FLECHA = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">'
    + '<path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  document.querySelectorAll('[data-runner]').forEach(function (riel) {
    if (riel.parentElement.classList.contains('cal-runnerwrap')) return;
    var caja = document.createElement('div');
    caja.className = 'cal-runnerwrap';
    riel.parentNode.insertBefore(caja, riel);
    caja.appendChild(riel);

    function boton(dir, etiqueta) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cal-runnerwrap__btn cal-runnerwrap__btn--' + dir;
      b.setAttribute('aria-label', etiqueta);
      b.innerHTML = FLECHA;
      caja.appendChild(b);
      return b;
    }
    var atras = boton('prev', 'Ver anteriores');
    var adelante = boton('next', 'Ver siguientes');

    function paso() {
      var t = riel.querySelector('.cal-mini, [data-runner-item]');
      return t ? t.offsetWidth + 24 : riel.clientWidth * 0.5;
    }
    function estado() {
      var max = riel.scrollWidth - riel.clientWidth;
      caja.classList.toggle('is-quieto', max <= 4);
      atras.disabled = riel.scrollLeft <= 2;
      adelante.disabled = riel.scrollLeft >= max - 2;
    }
    atras.addEventListener('click', function () { riel.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    adelante.addEventListener('click', function () { riel.scrollBy({ left: paso(), behavior: 'smooth' }); });
    riel.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    estado();
  });
})();

/* --------------------------------------------------------------------------
   Una sola fila de header.
   En vez de meter el buscador dentro del header del tema (que no tiene un
   hueco para un campo abierto), traemos los ÍCONOS del tema a nuestra fila y
   escondemos la suya. Mover el nodo conserva su comportamiento: el carrito
   sigue abriendo el cajón del tema y la cuenta sigue funcionando.
   -------------------------------------------------------------------------- */
(function () {
  var fila = document.querySelector('.cal-searchbar__inner');
  if (!fila) return;

  var carro = document.querySelector('.header-section a[href$="/cart"], .header-section cart-icon, .header a[href$="/cart"], .header cart-icon');
  if (!carro) return;

  // la sección del tema donde vive el header, capturada ANTES de mover nada.
  // En un grupo de secciones el id del nodo no es predecible, así que se
  // guarda la referencia en vez de intentar adivinar un selector.
  var seccionDelTema = carro.closest('.shopify-section');

  // el grupo de acciones del header: subimos hasta el contenedor que además
  // tiene la cuenta o la búsqueda del tema
  var grupo = carro.parentElement;
  var tope = 0;
  while (grupo && tope < 6) {
    if (grupo.querySelector('a[href*="/account"], [class*="search"], button')) break;
    grupo = grupo.parentElement;
    tope++;
  }
  if (!grupo) grupo = carro.parentElement;

  // El menú de hamburguesa del tema también se trae. Es el único acceso a la
  // navegación en teléfono, y sin él no se puede esconder la fila del tema
  // en pantallas chicas: quedaban DOS cabeceras, la del tema con el nombre en
  // texto y la nuestra con el buscador solo.
  // OJO: hay que mover el COMPONENTE <header-drawer>, no el <details> de
  // adentro. Horizon resuelve ref="details" y on:click="/toggle" dentro del
  // subarbol del componente; si se saca el details, el clic deja de abrir el
  // menu pero el atributo scroll-lock del details igual se dispara: la pagina
  // queda bloqueada sin menu a la vista.
  var disparador = seccionDelTema
    ? seccionDelTema.querySelector('header-drawer, details.menu-drawer-container, .header__icon--menu')
    : null;
  var hamburguesa = disparador && (
    disparador.closest('header-drawer')
    || disparador.closest('details.menu-drawer-container')
    || disparador
  );
  if (hamburguesa) {
    hamburguesa.classList.add('cal-searchbar__menu');
    fila.insertBefore(hamburguesa, fila.firstChild);

    // El pie del cajon (tira de productos + accesos) viaja adentro del panel.
    // Se hace por JS para no tocar header-drawer.liquid del tema.
    var pie = document.querySelector('[data-cal-menufoot]');
    var panel = hamburguesa.querySelector('.menu-drawer');
    if (pie && panel) {
      pie.hidden = false;
      panel.appendChild(pie);
    }
  }

  grupo.classList.add('cal-headericonos');
  // van dentro del bloque derecho, para que la grilla de tres columnas deje
  // el buscador en el centro real de la página
  var derecha = fila.querySelector('[data-header-derecha]') || fila;
  derecha.appendChild(grupo);

  // Recién ahora, con los íconos ya rescatados, se esconde la fila del tema.
  // Se oculta el nodo capturado, no un selector adivinado. Si el JS falla,
  // el header del tema sigue ahí y no se pierde el acceso al carrito.
  if (seccionDelTema && seccionDelTema !== document.querySelector('.cal-searchbar')?.closest('.shopify-section')) {
    seccionDelTema.classList.add('cal-header-oculto');
  }
  document.documentElement.classList.add('cal-header-migrado');
})();

/* --------------------------------------------------------------------------
   Buscador predictivo.
   Usa el endpoint nativo de Shopify /search/suggest.json. Ojo: ese endpoint
   calza por PREFIJO de palabra, no por coincidencia parcial.
   -------------------------------------------------------------------------- */
(function () {
  var campo = document.querySelector('.cal-searchbar__input');
  var panel = document.querySelector('[data-sug]');
  if (!campo || !panel) return;

  var lista = panel.querySelector('[data-sug-lista]');
  var todos = panel.querySelector('[data-sug-todos]');
  var reloj = null;
  var ultimo = '';

  function cerrar() { panel.hidden = true; }
  function money(c) {
    return '$' + (c / 100).toLocaleString('es-CL', { maximumFractionDigits: 0 });
  }

  function pintar(items, q) {
    if (!items.length) { cerrar(); return; }
    lista.innerHTML = items.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      return '<li><a class="cal-sug" href="' + p.url + '">'
        + (img ? '<span class="cal-sug__foto"><img src="' + img + '&width=120" alt="" loading="lazy"></span>' : '<span class="cal-sug__foto"></span>')
        + '<span class="cal-sug__txt">'
        + (p.vendor ? '<span class="cal-sug__marca">' + p.vendor + '</span>' : '')
        + '<span class="cal-sug__nombre">' + p.title + '</span>'
        + '</span>'
        + '<span class="cal-sug__precio">' + money(parseFloat(p.price)) + '</span>'
        + '</a></li>';
    }).join('');
    todos.setAttribute('href', '/search?q=' + encodeURIComponent(q));
    todos.textContent = 'Ver todos los resultados de "' + q + '"';
    panel.hidden = false;
  }

  function buscar(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.resources || !d.resources.results) { cerrar(); return; }
        pintar(d.resources.results.products || [], q);
      })
      .catch(cerrar);
  }

  campo.addEventListener('input', function () {
    var q = campo.value.trim();
    if (q === ultimo) return;
    ultimo = q;
    clearTimeout(reloj);
    if (q.length < 2) { cerrar(); return; }
    reloj = setTimeout(function () { buscar(q); }, 220);
  });

  campo.addEventListener('focus', function () { if (lista.children.length && campo.value.trim().length > 1) panel.hidden = false; });
  document.addEventListener('click', function (e) { if (!e.target.closest('.cal-searchbar__form')) cerrar(); });
  campo.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
})();

/* --------------------------------------------------------------------------
   Favoritos.
   Shopify no trae lista de deseos y no queremos obligar a crear cuenta, así
   que se guarda en el navegador. Se guarda también el nombre, la foto y el
   precio, para poder mostrar el panel sin pedirle nada a la red.
   -------------------------------------------------------------------------- */
(function () {
  var LLAVE = 'calibre:favoritos';

  function leer() {
    try {
      var d = JSON.parse(localStorage.getItem(LLAVE) || '[]');
      // compatibilidad con la primera versión, que guardaba solo ids
      return d.map(function (x) { return typeof x === 'string' ? { id: x } : x; });
    } catch (e) { return []; }
  }
  function guardar(lista) {
    try { localStorage.setItem(LLAVE, JSON.stringify(lista)); } catch (e) {}
  }
  function indice(lista, id) {
    for (var i = 0; i < lista.length; i++) { if (lista[i].id === id) return i; }
    return -1;
  }

  var panel = document.querySelector('[data-favpanel]');
  // El panel se cuelga del body: dentro del header, que es sticky y se
  // transforma, un position:fixed queda anclado al header y no a la ventana.
  if (panel && panel.parentElement !== document.body) {
    panel.hidden = true;
    document.body.appendChild(panel);
  }
  var lista = panel ? panel.querySelector('[data-favpanel-lista]') : null;
  var vacio = panel ? panel.querySelector('[data-favpanel-vacio]') : null;
  var cuenta = document.querySelector('[data-favpanel-cuenta]');

  function pintarBotones() {
    var g = leer();
    document.querySelectorAll('[data-fav]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(indice(g, b.dataset.fav) !== -1));
    });
    if (cuenta) {
      cuenta.textContent = g.length;
      cuenta.hidden = g.length === 0;
    }
  }

  function pintarPanel() {
    if (!lista) return;
    var g = leer();
    lista.innerHTML = g.map(function (p) {
      return '<li class="cal-favitem">'
        + '<a class="cal-favitem__link" href="' + (p.url || '#') + '">'
        + '<span class="cal-favitem__foto">' + (p.foto ? '<img src="' + p.foto + '" alt="" loading="lazy">' : '') + '</span>'
        + '<span class="cal-favitem__txt">'
        + (p.marca ? '<span class="cal-favitem__marca">' + p.marca + '</span>' : '')
        + '<span class="cal-favitem__nombre">' + (p.titulo || '') + '</span>'
        + '<span class="cal-favitem__precio">' + (p.precio || '') + '</span>'
        + '</span></a>'
        + '<button type="button" class="cal-favitem__quitar" data-favquitar="' + p.id + '" aria-label="Quitar de favoritos">✕</button>'
        + '</li>';
    }).join('');
    if (vacio) vacio.hidden = g.length > 0;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav]');
    if (b) {
      e.preventDefault();
      var g = leer();
      var i = indice(g, b.dataset.fav);
      if (i === -1) {
        g.push({
          id: b.dataset.fav,
          url: b.dataset.favUrl,
          titulo: b.dataset.favTitulo,
          marca: b.dataset.favMarca,
          precio: b.dataset.favPrecio,
          foto: b.dataset.favFoto
        });
      } else { g.splice(i, 1); }
      guardar(g);
      pintarBotones();
      pintarPanel();
      return;
    }

    var q = e.target.closest('[data-favquitar]');
    if (q) {
      var g2 = leer();
      var j = indice(g2, q.dataset.favquitar);
      if (j !== -1) { g2.splice(j, 1); guardar(g2); }
      pintarBotones();
      pintarPanel();
      return;
    }

    if (e.target.closest('[data-favpanel-abrir]')) {
      pintarPanel();
      if (panel) panel.hidden = false;
      return;
    }
    if (e.target.closest('[data-favpanel-cerrar]') || (panel && !panel.hidden && e.target === panel)) {
      panel.hidden = true;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel && !panel.hidden) panel.hidden = true;
  });

  pintarBotones();
})();

/* --------------------------------------------------------------------------
   Header que se esconde al bajar y vuelve al subir.
   La página no siempre scrollea en window: Horizon usa un contenedor propio,
   así que escuchamos en los dos.
   -------------------------------------------------------------------------- */
(function () {
  var barra = document.querySelector('.cal-searchbar');
  if (!barra) return;
  var seccion = barra.closest('.shopify-section') || barra;
  seccion.classList.add('cal-sticky');

  var contenedor = document.querySelector('.page-wrapper');
  var previo = 0;
  var UMBRAL = 8;      // ruido de scroll que no cuenta
  var DESDE = 160;     // no se esconde en la parte alta de la página

  function pos() {
    if (contenedor && contenedor.scrollHeight > contenedor.clientHeight + 4) return contenedor.scrollTop;
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  var pendiente = false;
  function revisar() {
    pendiente = false;
    var y = pos();
    var d = y - previo;
    if (Math.abs(d) < UMBRAL) return;
    if (y > DESDE && d > 0) {
      seccion.classList.add('cal-sticky--fuera');
    } else {
      seccion.classList.remove('cal-sticky--fuera');
    }
    seccion.classList.toggle('cal-sticky--flotando', y > 4);
    previo = y;
  }
  function alScroll() {
    if (pendiente) return;
    pendiente = true;
    // sin rAF: en pestañas en segundo plano rAF se congela y el header
    // quedaría trabado en el último estado
    setTimeout(revisar, 60);
  }

  window.addEventListener('scroll', alScroll, { passive: true });
  if (contenedor) contenedor.addEventListener('scroll', alScroll, { passive: true });
  revisar();
})();

/* --------------------------------------------------------------------------
   Ficha de producto: utilería sobre la foto y pestañas bajo la galería.

   El bloque de galería de Horizon es estático y no admite hijos, así que la
   marca de "más vendido", el favorito y el compartir se declaran en la
   sección de pestañas y se suben aquí sobre el escenario.

   El escenario NO se busca por nombre de clase: las clases internas del tema
   base cambian entre versiones. Se busca por geometría, subiendo desde la
   primera imagen hasta el primer ancestro que ya sea tan ancho como la
   columna. Eso sobrevive a un cambio de nombres.
   -------------------------------------------------------------------------- */
(function () {
  var media = document.querySelector('.product-information__media');
  if (!media) return;

  function montar() {
    var img = media.querySelector('img');
    if (!img) return false;

    // El número real de fotos lo dice Liquid, no se adivina contando nodos:
    // las miniaturas también son <img> y el conteo salía mal.
    var info = document.querySelector('[data-pdp-info]');
    var fotos = info ? parseInt(info.dataset.fotos, 10) : 0;
    if (!fotos || isNaN(fotos)) fotos = 1;

    // Se sube hasta el ancestro que sea tan ancho como la columna Y que
    // contenga TODAS las fotos. Sin la segunda condición el marco podía
    // quedar en una diapositiva suelta y el borde se movía con el carrusel.
    var nodo = img.parentElement;
    var marco = null;
    while (nodo && nodo !== media) {
      if (nodo.offsetWidth >= media.offsetWidth * 0.6 &&
          nodo.querySelectorAll('img').length >= fotos) { marco = nodo; break; }
      nodo = nodo.parentElement;
    }
    if (!marco) marco = media;
    marco.classList.add('cal-marco');

    // Una sola foto: la tira de miniaturas sobra y deja un hueco feo.
    if (fotos <= 1) media.classList.add('cal-una-foto');

    // Se separa el CARRIL de las MINIATURAS. Antes se marcaban los dos igual
    // y el borde terminaba dibujado también alrededor del grupo completo.
    media.querySelectorAll('[class*="humbnail"]').forEach(function (m) {
      if (m.querySelector('[class*="humbnail"]')) {
        m.classList.add('cal-minirail');
      } else if (m.querySelector('img') || m.tagName === 'IMG') {
        m.classList.add('cal-minimarco');
      }
    });

    var utiles = document.querySelector('[data-pdp-utiles]');
    if (utiles && utiles.parentElement !== marco) {
      utiles.hidden = false;
      marco.appendChild(utiles);
    }
    var flag = document.querySelector('.cal-pdp-flag');
    if (flag && flag.parentElement !== marco) {
      flag.classList.add('cal-pdp-flag--sobre');
      marco.appendChild(flag);
    }
    return true;
  }

  if (!montar()) {
    // La galería puede hidratarse después. Se reintenta una vez al cargar.
    window.addEventListener('load', montar, { once: true });
  }
})();

/* Pestañas del detalle */
(function () {
  var caja = document.querySelector('[data-pestanas]');
  if (!caja) return;
  caja.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pestana]');
    if (!b) return;
    var destino = b.dataset.pestana;
    caja.querySelectorAll('[data-pestana]').forEach(function (t) {
      var activa = t === b;
      t.classList.toggle('is-activa', activa);
      t.setAttribute('aria-selected', String(activa));
    });
    caja.querySelectorAll('[data-panel]').forEach(function (p) {
      p.hidden = p.dataset.panel !== destino;
    });
  });
})();

/* Compartir. Usa el menú nativo del teléfono y, si no existe, copia el enlace. */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-compartir]');
    if (!b) return;
    var url = b.dataset.url;
    var titulo = b.dataset.titulo || document.title;
    if (navigator.share) {
      navigator.share({ title: titulo, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        b.classList.add('is-copiado');
        setTimeout(function () { b.classList.remove('is-copiado'); }, 1800);
      }).catch(function () {});
    }
  });
})();

/* --------------------------------------------------------------------------
   Carga de la pagina siguiente en una coleccion.

   Horizon YA precarga la pagina siguiente antes de que llegues al final:
   paginated-list llama a fetchPage("next") apenas se monta y otra vez en
   cuanto pinta una tanda. Al llegar abajo las tarjetas se agregan desde
   memoria y aparecen al instante.

   Por eso aca NO se retiene nada. La version anterior guardaba las tarjetas
   invisibles 1,1 s para que "se notara" la carga, y el efecto real era el
   contrario: un hueco en blanco justo donde ya habia productos puestos.

   Ahora el aviso sale solo mientras el centinela esta a la vista y todavia
   quedan paginas, y las tarjetas entran con un fundido corto.
   -------------------------------------------------------------------------- */
(function () {
  var raiz = document.querySelector('results-list') || document.querySelector('.product-grid-container');
  if (!raiz) return;

  var aviso = null;

  function grid() { return raiz.querySelector('.product-grid'); }

  // data-last-page lo escribe el tema en la grilla y cada tarjeta sabe de que
  // pagina vino. Con eso se sabe si de verdad queda algo por cargar, y el
  // aviso no se queda girando al final de la coleccion.
  function quedanPaginas() {
    var g = grid();
    if (!g) return false;
    var ultima = parseInt(g.dataset.lastPage, 10);
    if (!ultima) return false;
    var items = g.querySelectorAll('.product-grid__item');
    var actual = items.length ? parseInt(items[items.length - 1].dataset.page, 10) : 1;
    return !actual || actual < ultima;
  }

  function encender() {
    if (aviso) return;
    var g = grid();
    if (!g || !g.parentElement) return;
    aviso = document.createElement('div');
    aviso.className = 'cal-cargando__aviso';
    aviso.setAttribute('role', 'status');
    aviso.innerHTML = '<span class="cal-cargando__rueda" aria-hidden="true"></span>'
      + '<span class="cal-cargando__txt">Cargando más productos</span>';
    g.parentElement.insertBefore(aviso, g.nextSibling);
  }

  function apagar() {
    if (!aviso) return;
    aviso.remove();
    aviso = null;
  }

  var centinela = raiz.querySelector('[ref="viewMoreNext"]');
  if (centinela && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting && quedanPaginas()) encender();
        else apagar();
      });
    }, { rootMargin: '200px' }).observe(centinela);
  }

  new MutationObserver(function (muts) {
    var nuevos = [];
    muts.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.classList && n.classList.contains('product-grid__item')) nuevos.push(n);
        else if (n.querySelectorAll) [].push.apply(nuevos, n.querySelectorAll('.product-grid__item'));
      });
    });
    if (!nuevos.length) return;
    apagar();
    nuevos.forEach(function (n, i) {
      n.classList.add('cal-entra');
      n.style.animationDelay = (Math.min(i, 8) * 35) + 'ms';
      setTimeout(function () {
        n.classList.remove('cal-entra');
        n.style.animationDelay = '';
      }, 900);
    });
  }).observe(raiz, { childList: true, subtree: true });
})();

/* --------------------------------------------------------------------------
   Pop-up. El contenido y los colores los define el editor; aquí solo vive el
   cuándo: el retardo, la memoria de "ya lo vio" y las tres formas de cerrarlo.

   En el editor de temas se muestra SIEMPRE, al instante y sin memoria, para
   que se pueda configurar mirándolo.
   -------------------------------------------------------------------------- */
(function () {
  var pop = document.querySelector('[data-popup]');
  if (!pop) return;

  var enEditor = window.Shopify && window.Shopify.designMode;

  /* El pop-up se declara dentro del grupo del pie de pagina, y ahi cualquier
     ancestro con transform, filter o contain le rompe el position:fixed: deja
     de medirse contra la ventana y se ancla al footer, con lo que abrirlo
     mandaba la pagina hasta abajo. Colgarlo del <body> lo deja siempre fijo
     contra la ventana, pase lo que pase con las secciones. */
  if (pop.parentElement !== document.body) document.body.appendChild(pop);

  var clave = pop.dataset.clave || 'calibre:popup';
  var dias = parseInt(pop.dataset.frecuencia, 10) || 0;
  var retardo = (parseInt(pop.dataset.retardo, 10) || 0) * 1000;
  var ultimoFoco = null;

  function vistoHacePoco() {
    if (dias <= 0) return false;
    try {
      var t = parseInt(localStorage.getItem(clave), 10);
      if (!t) return false;
      return (Date.now() - t) < dias * 86400000;
    } catch (e) { return false; }
  }

  function recordar() {
    try { localStorage.setItem(clave, String(Date.now())); } catch (e) {}
  }

  function abrir() {
    ultimoFoco = document.activeElement;
    var y = window.scrollY;
    pop.hidden = false;
    var foco = pop.querySelector('input, a, button:not([data-popup-cerrar])') || pop.querySelector('[data-popup-cerrar]');
    if (foco) foco.focus({ preventScroll: true });
    // Seguro: preventScroll no lo respetan todos los navegadores moviles.
    // Si la pagina se movio al dar el foco, se devuelve donde estaba.
    if (window.scrollY !== y) window.scrollTo(0, y);
    requestAnimationFrame(function () {
      if (window.scrollY !== y) window.scrollTo(0, y);
    });
  }

  function cerrar() {
    pop.hidden = true;
    if (!enEditor) recordar();
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
  }

  pop.addEventListener('click', function (e) {
    if (e.target.closest('[data-popup-cerrar]')) { e.preventDefault(); cerrar(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !pop.hidden) cerrar();
  });

  if (enEditor) { abrir(); return; }
  if (vistoHacePoco()) return;

  // Si se envió el formulario, Shopify recarga con el resultado: se muestra
  // de inmediato para que la clienta vea la confirmación.
  if (pop.querySelector('.cal-popup__ok')) { abrir(); return; }

  setTimeout(abrir, retardo);
})();
